// eslint-disable-next-line @typescript-eslint/naming-convention
export type primitive = number | boolean | string | null | Date;

export default function isPrimitive(type: any): type is primitive {
  return typeof type === 'string'
  || typeof type === 'number'
  || typeof type === 'boolean'
  || type === null
  || type instanceof Date;
}
